/**
 * Review page row / filter ordering: Rejected → in-review chain → Approved → Payroll → Paid;
 * other statuses (e.g. Not Started, Upload, Busted) last.
 */
export function reviewPageStatusSortRank(statusTypeId: number): number {
  switch (statusTypeId) {
    case 7:
      return 0;
    case 2:
    case 3:
    case 4:
    case 5:
      return 1;
    case 6:
      return 2;
    case 9:
      return 3;
    case 10:
      return 4;
    default:
      return 5;
  }
}

export function compareBonusesForReviewPage(
  a: { statusTypeId: number; jobId: number },
  b: { statusTypeId: number; jobId: number }
): number {
  const ra = reviewPageStatusSortRank(a.statusTypeId);
  const rb = reviewPageStatusSortRank(b.statusTypeId);
  if (ra !== rb) return ra - rb;
  if (ra === 1 || ra === 5) {
    const byStatus = a.statusTypeId - b.statusTypeId;
    if (byStatus !== 0) return byStatus;
  }
  return a.jobId - b.jobId;
}
